const isOriginTrusted = (origin) => {
  try {
    const originHostname = new URL(origin).hostname;
    return originHostname === window.location.hostname;
  } catch {
    return false;
  }
};

const isSafeRedirectUrl = (url) => {
  if (!url || typeof url !== 'string') return false;

  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.origin === window.location.origin;
  } catch {
    return false;
  }
};

export { isOriginTrusted, isSafeRedirectUrl };
